// extracted by mini-css-extract-plugin
export default {"ebanner":"_g-z"};